import { Component, Input } from '@angular/core';
import { BasicComponent } from '../../basic-component';

@Component({
    selector: 'app-docking-flight-info',
    templateUrl: './docking-flight-info.component.html',
    styleUrls: ['./docking-flight-info.component.scss']
})
export class DockingFlightInfoComponent extends BasicComponent {
    @Input()
    timeString: string;
    @Input()
    timeType: string;
    @Input()
    flightIconName: string;
}
